module.exports = __webpack_public_path__ + "img/madden nat champ white.ee584cd4.png";